(function () {
  // Only run on the Minimalist Flatware 2.0 PDP (any locale prefix, e.g. /en-sg/products/...)
  try {
    var path = window.location.pathname || '';
    if (path.length > 1 && path.endsWith('/')) {
      path = path.slice(0, -1);
    }
    if (path.indexOf('/products/minimalist-flatware-2-0') === -1) {
      return;
    }
  } catch (e) {
    return;
  }

  function injectZoomStyles() {
    if (document.getElementById('mf20-inline-zoom-style')) return;
    var style = document.createElement('style');
    style.id = 'mf20-inline-zoom-style';
    style.textContent =
      '@media screen and (min-width: 992px) {' +
      '.mf20-zoom-btn{position:absolute;top:14px;right:14px;z-index:12;display:inline-flex;align-items:center;justify-content:center;opacity:0;pointer-events:none;transition:opacity .2s ease;border:1px solid #050d37;border-radius:999px;background:#fff;color:#050d37;width:42px;height:42px;padding:0;cursor:pointer;box-shadow:0 4px 12px rgba(5,13,55,.12)}' +
      'html.mf20-zoom-ab-on .mf20-zoom-btn,body.mf20-zoom-ab-on .mf20-zoom-btn{opacity:1;pointer-events:auto}' +
      '.mf20-zoom-btn:hover{background:#050d37;color:#fff}' +
      '.mf20-zoom-btn svg{width:22px;height:22px;display:block}' +
      '.mf20-zoom-btn svg path{stroke:currentColor}' +
      'zoom-cursor,.zoom-cursor,.product__zoom,.product-media__zoom{display:none;opacity:0;visibility:hidden;pointer-events:none}' +
      '[data-zoom-cursor-target]{cursor:auto;background-image:none}' +
      '.mf20-inline-zoom-host{overflow:hidden;cursor:zoom-in}' +
      '.mf20-inline-zoom-host.is-zoomed{cursor:zoom-out}' +
      '.mf20-inline-zoom-host img.mf20-inline-zoom-target{transition:transform .2s ease;transform-origin:var(--mf20-zoom-x,50%) var(--mf20-zoom-y,50%);will-change:transform}' +
      '.mf20-inline-zoom-host.is-zoomed img.mf20-inline-zoom-target{transform:scale(var(--mf20-zoom-scale,2.2))}' +
      '}';
    document.head.appendChild(style);
  }

  function getMediaHost() {
    return (
      document.querySelector('[data-product-media-container] .product-media-swiper') ||
      document.querySelector('.product-desktop-media .product-media-swiper') ||
      document.querySelector('.product-media-swiper') ||
      document.querySelector('.custom-product .product-media-carousel') ||
      document.querySelector('.custom-product .product-media') ||
      document.querySelector('.product-media-carousel')
    );
  }

  function getActiveSlide() {
    return (
      document.querySelector('.product-media-swiper .main-swiper .swiper-slide-active') ||
      document.querySelector('.product-media-carousel__slide.is-selected') ||
      document.querySelector('.product-media-carousel-mobile__slide.is-selected')
    );
  }

  function getActiveImage() {
    var activeSlide = getActiveSlide();
    if (!activeSlide) return null;
    return activeSlide.querySelector('img.product-media-swiper__image, img.product-media__image, img');
  }

  var zoomState = {
    enabled: false,
    scale: 2.2,
    currentHost: null,
    currentImage: null,
  };

  function clearCurrentZoomTarget() {
    if (zoomState.currentHost) {
      zoomState.currentHost.classList.remove('mf20-inline-zoom-host', 'is-zoomed');
      zoomState.currentHost.style.removeProperty('--mf20-zoom-x');
      zoomState.currentHost.style.removeProperty('--mf20-zoom-y');
      zoomState.currentHost.style.removeProperty('--mf20-zoom-scale');
    }
    if (zoomState.currentImage) {
      zoomState.currentImage.classList.remove('mf20-inline-zoom-target');
    }
    zoomState.currentHost = null;
    zoomState.currentImage = null;
  }

  function applyZoomToActiveImage() {
    clearCurrentZoomTarget();
    var activeSlide = getActiveSlide();
    var activeImage = getActiveImage();
    if (!activeSlide || !activeImage) return;

    activeSlide.classList.add('mf20-inline-zoom-host');
    activeImage.classList.add('mf20-inline-zoom-target');
    activeSlide.style.setProperty('--mf20-zoom-scale', String(zoomState.scale));
    if (zoomState.enabled) activeSlide.classList.add('is-zoomed');

    zoomState.currentHost = activeSlide;
    zoomState.currentImage = activeImage;
  }

  function setZoomEnabled(enabled) {
    zoomState.enabled = enabled;
    applyZoomToActiveImage();
    var btn = document.querySelector('.mf20-zoom-btn');
    if (btn) btn.setAttribute('aria-pressed', enabled ? 'true' : 'false');
  }

  function mountZoomButton() {
    if (window.innerWidth < 992) return;
    if (document.querySelector('.mf20-zoom-btn')) return;
    var mediaHost = getMediaHost();
    if (!mediaHost) return;

    if (getComputedStyle(mediaHost).position === 'static') {
      mediaHost.style.position = 'relative';
    }

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'mf20-zoom-btn';
    btn.setAttribute('aria-label', 'Toggle zoom');
    btn.setAttribute('aria-pressed', 'false');
    btn.innerHTML =
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" aria-hidden="true">' +
      '<path d="M7 10H10M10 10H13M10 10V7M10 10V13M15 15L21 21M10 17C6.13401 17 3 13.866 3 10C3 6.13401 6.13401 3 10 3C13.866 3 17 6.13401 17 10C17 13.866 13.866 17 10 17Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>' +
      '</svg>';
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      setZoomEnabled(!zoomState.enabled);
    });
    mediaHost.appendChild(btn);
  }

  function bindZoomInteractions() {
    document.addEventListener('mousemove', function (e) {
      if (!zoomState.enabled || !zoomState.currentHost) return;
      var rect = zoomState.currentHost.getBoundingClientRect();
      if (!rect.width || !rect.height) return;
      var x = ((e.clientX - rect.left) / rect.width) * 100;
      var y = ((e.clientY - rect.top) / rect.height) * 100;
      if (x < 0 || x > 100 || y < 0 || y > 100) return;
      zoomState.currentHost.style.setProperty('--mf20-zoom-x', x.toFixed(2) + '%');
      zoomState.currentHost.style.setProperty('--mf20-zoom-y', y.toFixed(2) + '%');
    });

    document.addEventListener('click', function (e) {
      if (!zoomState.enabled || !zoomState.currentHost) return;
      if (!e.target.closest('.mf20-inline-zoom-host')) return;
      e.preventDefault();
      setZoomEnabled(false);
    });
  }

  function boot() {
    document.querySelectorAll('.mf20-zoom-modal').forEach(function (node) {
      node.remove();
    });
    injectZoomStyles();
    mountZoomButton();
    bindZoomInteractions();
    applyZoomToActiveImage();

    setTimeout(mountZoomButton, 300);
    setTimeout(mountZoomButton, 900);

    // When the active media slide changes, always reset zoom state
    setInterval(function () {
      var activeImage = getActiveImage();
      if (!activeImage && zoomState.currentImage) {
        zoomState.enabled = false;
        clearCurrentZoomTarget();
        return;
      }
      if (activeImage && activeImage !== zoomState.currentImage) {
        zoomState.enabled = false;
        clearCurrentZoomTarget();
      }
    }, 250);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
